/*
 *   File : manage-banner.js
 *   Author URI : https://evoqins.com
 *   Description : UI element for adding banner
 *   Integrations : react-toastify
 *   Version : v1.1
 */


/* import packages */
import { useEffect, useState } from "react";
import { toast } from "react-toastify";

/* import components */
import { GradientButton } from "../Cta";
import { Icon } from "../Icon";
import { FilePreview } from "../Cards";
import { CustomTextInput, FileUpload } from "../FormElements";

/* import styles */
import style from "../../Styles/Components/banner.module.scss";

/* import helper */
import { closeModal } from "../../Helper/helper-function";
import { _uploadDocumentToS3 } from "../../Services/aws-service";
import APIService from "../../Services/api-service";

const ManageBannerModal = (props) => {
    const [fileName, setFileName] = useState(null);
    const [fileError, setFileError] = useState(null);
    const [fileUrl, setFileUrl] = useState('');
    const [redirectionUrl, setRedirectionUrl] = useState(null);
    const [fileLoader, setFileLoader] = useState(false);
    const [apiLoader, setApiLoader] = useState(false);

    useEffect(() => {
        var my_modal = document.getElementById("add-banner");
        my_modal.addEventListener("hidden.bs.modal", () => {
            props.close();
            setFileError('');
            setFileName('');
            setFileUrl('');
        });
    }, [props.close]);

    // handler for file
    function _handleInput(input) {

        setRedirectionUrl(input);
    }

    function _fileHandler(path, file) {
        var file_formatted = path.replace(/^.*[\\\/]/, '').split('/');
        file_formatted = file_formatted[0].replace(/[\(\)\s]/g, ''); //returning path
        const file_type = file.type;

        if (_verifyFileType(file_type)) {
            _fileUpload(file_formatted, file);
            setFileError("");
        }
        else {
            toast.dismiss();
            toast.error("File format should be in png, jpg or jpeg", {
                type: "error",
            });
        }
    }

    function _verifyFileType(fileType) {
        const valid_mime_type = [
            "image/png", // .png
            "image/jpeg", // .jpg, .jpeg
        ];
        return valid_mime_type.includes(fileType);
    }

    // form validation 
    function _validateForm() {
        let valid_form = true;

        if (fileUrl === '') {
            valid_form = false;
            setFileError("File is require");
        }

        //eslint-disable-next-line
        else if (valid_form = true) {
            _addBanner();
        }
    }


    // API - file upload
    const _fileUpload = (key, file) => {
        setFileLoader(true);
        let url = "general/file-upload";
        let body = {
            "key": `banner/${key}`,
            is_public: true
        }

        APIService(true, url, body).then(async (response) => {
            if (response.status_code === 200) {
                setFileLoader(true)

                // s3 helper
                await _uploadDocumentToS3(response.data, key, file).then((result) => {
                    setFileUrl(response.data.view_info); // file got uploaded successfully
                    setFileLoader(false);
                    setFileName(key);
                }).catch(error => {
                    toast.dismiss();
                    toast.error(error, {
                        type: "error",
                    });
                    setFileLoader(false);
                });
            } else {
                setFileLoader(false);
                toast.dismiss();
                toast.error(response, {
                    type: "error",
                });
            }
        })
    }


    // API - Add banner
    const _addBanner = () => {
        setApiLoader(true);
        const url = "banner/upsert";
        const data = {
            image_url: fileUrl,
            redirection_url: redirectionUrl
        }

        APIService(true, url, data).then((response) => {
            if (response.status_code === 200) {
                props.updateBanner()
                closeModal("add-banner");
                toast.dismiss();
                toast.success('Banner added successfully', {
                    type: "success",
                });
            } else {
                toast.dismiss();
                toast.error(response.message, {
                    type: "error",
                });
            }
            setApiLoader(false);
        })
    }


    return (
        <div className={`modal fade ${style.e_delete}`}
            id="add-banner"
            tabIndex="-1"
            aria-labelledby="add-banner"
            aria-hidden="true"
            data-bs-backdrop="true" >
            <div className={`modal-dialog position-relative modal-dialog-centered ${style.e_dialog}`}>
                <div className={`modal-content bg-white padding-32px-all ${style.e_content} `}>
                    <div className="col-12 d-flex justify-content-between">
                        <h3 className="color-black e-poppins-semi-bold e-font-18">
                            Add new banner
                        </h3>
                        <Icon icon="close"
                            size={24}
                            className="cursor-pointer ms-auto e-modal-close-btn"
                            data-bs-dismiss="modal" />
                    </div>
                    <div className="col-12 text-start padding-32px-top">
                        <label className="pb-3 color-light-black e-font-14 line-height-14px e-poppins-regular text-start">
                            Add banner image
                        </label>
                        <span className="d-block mb-2 e-font-12">Preferred file dimensions: 1096 x 270.</span>


                        {/* file picker */}
                        <FileUpload id="e-upload"
                            error={fileError}
                            loading={fileLoader}
                            accept=".png, .jpg, .jpeg "
                            hide_error_text={true}
                            onSelectFile={(path, file) => {
                                _fileHandler(path, file)
                            }} />
                        {
                            fileUrl ?
                                <FilePreview file={fileName}
                                    clearFile={() => {
                                        setFileName("");
                                        setFileUrl("");
                                    }} />

                                :
                                null
                        }
                    </div>

                    {/* redirection URL */}
                    <div className="col-12 padding-24px-top">
                        <CustomTextInput label="Redirection url"
                            value={redirectionUrl}
                            type="text"
                            onEnter={_validateForm}
                            valueChange={(input_value) => {
                                _handleInput(input_value)
                            }} />
                    </div>

                    {/* save banner button */}
                    <div className="col-12 padding-24px-top ">
                        <GradientButton label="Save banner"
                            loading={apiLoader}
                            className="padding-12px-tb e-font-16 "
                            onPress={_validateForm} />
                    </div>
                </div>
            </div>
        </div>
    )
}


ManageBannerModal.defaultProps = {
    close: () => { },
    fund: {
        fund_name: ""
    }
}

export default ManageBannerModal
